import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const SportScaleSecondaryButton = ({ className, children, ...restProps }) => {
  const classes = useStyles();

  return (
    <Button variant="contained" color="secondary" className={classNames(classes.root, className)} {...restProps}>
      {children}
    </Button>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    borderRadius: '0.2rem',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    '&:focus': {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    '&:disabled': {
      boxShadow: 'none',
      backgroundColor: theme.palette.grey[500],
    },
  },
}));

SportScaleSecondaryButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
};

SportScaleSecondaryButton.defaultProps = {
  className: null,
};

export default SportScaleSecondaryButton;
